// extracted by mini-css-extract-plugin
export default {"galleryDivImg":"Profile_galleryDivImg__cSZ9v"};